import React, { forwardRef, useEffect, useRef } from 'react'
import styled from 'styled-components'
import LiveTooltip from 'live/components/ui/tooltip'
import { timestampToDate } from '../../../utils/DateUtils'

type Props = {
    style?: StyleSheet
    name: string
    styledName?: StyleSheet
    value: string
    styledValue?: StyleSheet
    info?: string
    styledInfo?: StyleSheet
    color?: string
    isTimestamp?: boolean
    className?: string
    showTooltip?: boolean
    tooltipInformation?: string
    onMouseEnter?: () => void
    onMouseLeave?: () => void
}

const ColumnText = ({
    style,
    name,
    styledName,
    value,
    styledValue,
    info,
    styledInfo,
    color,
    isTimestamp,
    className,
    showTooltip = false,
    tooltipInformation,
    onMouseEnter,
    onMouseLeave
}: Props): JSX.Element => {
    const format = (value): unknown => (isTimestamp ? timestampToDate(value) : value)

    return (
        <Wrapper style={style} className={className} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <Title style={styledName}>
                {name}

                <span
                    style={{
                        visibility: showTooltip ? 'visible' : 'hidden',
                        opacity: showTooltip ? 1 : 0,
                        transition: 'opacity 0.3s ease'
                    }}
                >
                    <LiveTooltip position="top" content={tooltipInformation}>
                        <i className={'far fa-info-circle'} style={{ fontSize: '14px' }} />
                    </LiveTooltip>
                </span>
            </Title>
            {color ? (
                <DivWithColor>
                    <Value style={styledValue}>{format(value)}</Value>
                    <DivPile>
                        <InfoPile style={{ backgroundColor: color, ...styledInfo }}> {info}</InfoPile>
                    </DivPile>
                </DivWithColor>
            ) : (
                <DivWithInfo>
                    <Value style={styledValue}>{format(value)}</Value>
                    {info ? <Info style={styledInfo}>{info}</Info> : null}
                </DivWithInfo>
            )}
        </Wrapper>
    )
}
export default ColumnText

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;

    text-transform: none;
    gap: 4px;
    div {
        font-family: SourceSansPro-Semibold, Arial, Helvetica Neue, Helvetica, sans-serif;
    }
`

const Title = styled.div`
    color: ${({ theme }) => theme['gray-700']};
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: 6px;
    line-height: 120% !important;

    .tooltipEDTESTE {
        display: block;
    }
`

export const Value = styled.div`
    color: ${({ theme }) => theme['gray-800']};
    font-size: 16px;
    font-weight: 600;
`
const Info = styled.div`
    color: ${({ theme }) => theme['gray-700']};
    font-size: 14px;
    font-weight: 400;
    font-style: italic;
    text-wrap: none;
`
export const InfoPile = styled.div`
    color: ${({ theme }) => theme['gray-700']};
    width: fit-content;
    padding: 2px 4px;
    border-radius: 3px;
    font-size: 16px;
    font-weight: 400;
    text-wrap: none;
`
export const DivWithColor = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
`
export const DivWithInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`
const DivPile = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`
